<template>
	<PageTemplate>
		<template slot="title">
			Leadership
		</template>
		<template slot="side">
			menu<br> menu<br> menu
		</template>
		<template slot="content">
			<v-layout>
				<v-flex xs12>
					<h2>Daniel Leahy, Co-Director</h2>
					<img src="img/leadership/daniel_leahy.jpg" alt="Daniel Leahy">
					<p>
					Dr. Leahy leads one of the College's largest departments, with 64 faculty, as well as one of its newest. The college established the Molecular Biosciences Department in 2013 as part of a reorganization designed in part to advance biomedical sciences and prepare the college for strong, ongoing collaboration with the Dell Medical School.
					<br>
					<br>
					Leahy received his Ph.D. in biophysics from Stanford University and his bachelor's degree in mathematics from Yale University. He conducted postdoctoral research at Columbia University before joining the faculty at Johns Hopkins.
					</p>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs12>
					<h2>David Taylor, Co-Director</h2>
					<img src="img/leadership/david_taylor.jpg" alt="David Taylor">
					<p>
					David Taylor received his B.S. in Biochemistry summa cum laude from Syracuse University in 2008. He completed his Ph.D. with distinction in Molecular Biophysics and Biochemistry at Yale University in 2013. In 2014, he joined the laboratories of Jennifer A. Doudna and Eva Nogales at the University of California, Berkeley as a Post-doctoral fellow, where he studied the structures of CRISPR complexes using cryo-electron microscopy. He started as an Assistant Professor in the Department of Molecular Biosciences at the University of Texas at Austin in 2016. He is the Director of the Sauer Structural Biology Laboratory and a member of the LIVESTRONG Cancer Institutes and the Center for Systems and Synthetic Biology.   He has won numerous awards during his career including. He’s been named a Barry M. Goldwater Scholar, an NSF Pre-doctoral Fellow, an NSF East Asia and Pacific Summer Institute fellow, a Damon Runyon Post-doctoral Fellow, and a CPRIT Scholar. He’s received the Outstanding Teaching Award and the Mary Ellen Jones Dissertation Prize from the Department of Molecular Biophysics and Biochemistry at Yale University. He also received the 2015 Outstanding Post-doctoral Fellow Award from the Department of Molecular and Cell Biology at the University of California, Berkeley.
					<br>
					<br>
						<a href="http://davidtaylorlab.com/" target="blank"><v-icon>open_in_new</v-icon> davidtaylorlab.com </a>
					</p>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs12>
					<h2>Axel Brilot, Cryo-EM Facility Manager</h2>
					<img src="img/leadership/axel_brilot.jpg" alt="Axel Brilot">
					<p>
	Axel Rocks.
					</p>
				</v-flex>
			</v-layout>
		</template>
	</PageTemplate>
</template>

<script>
import PageTemplate from './PageTemplate'
export default {
  name: 'leadship',
  data () {
    return {
      
    }
  },
  components:{
	PageTemplate
  }
}
</script>

<style scoped>
img{
	max-width:300px;
	width:38%;
	height:auto;
	border: 1px solid #cccccc;
	padding:5px;
	float:right;
	margin-left:20px;
}
p{
	padding-left:15px;
	text-align:justify;
}
</style>



// WEBPACK FOOTER //
// src/components/Leadership.vue